module.exports = __webpack_public_path__ + "img/5.259b4fb0.png";